/**
 * LÄGESVÄXELN — "Mitt jobb" / "Laget".
 *
 * DEN RENDERAR null NÄR VÄXLING INTE FINNS. Ingen inaktiverad knapp, ingen
 * gömd flik, ingen tooltip som förklarar. En montör ska inte se att det finns
 * ett andra läge — se app/lage.tsx för hela resonemanget och de fyra
 * spärrarna.
 *
 * Placera den HÖGST UPP på båda startsidorna, precis som prototypen gör.
 */

import { useLage } from '../app/lage';

/**
 * `dolj` — växeln finns men ska inte visas just nu.
 *
 * Det enda läget som använder den: en firma som ännu inte är igång. Innan det
 * finns timpris, moment och ett jobb kan Laget-läget inte innehålla någonting —
 * ingenting att attestera, ingen ute på ett jobb, inget att fakturera — och två
 * flikar där den ena garanterat är tom är två flikar för mycket för den som
 * öppnar appen första gången. Så fort firman är igång finns växeln, också för
 * den som är ensam: "Att fakturera" är det en ensamfirma behöver mest.
 *
 * DEN SKILJER SIG FRÅN `kanSeLaget`, som är en RÄTTIGHET och avgör om skärmarna
 * ens finns i kartan (app/skarmar.ts). Den här är en tidpunkt.
 */
export const Lagesvaxel = ({ dolj = false }: { readonly dolj?: boolean }) => {
  const styrning = useLage();
  if (!styrning.kanSeLaget || dolj) return null;

  return (
    <div className="lagesvaxel" role="group" aria-label="Läge">
      <button
        type="button"
        aria-pressed={styrning.lage === 'hem'}
        onClick={() => styrning.vaxla('hem')}
      >
        Mitt jobb
      </button>
      <button
        type="button"
        aria-pressed={styrning.lage === 'lag'}
        onClick={() => styrning.vaxla('lag')}
      >
        Laget
      </button>
    </div>
  );
};
